import { Statement, StatementGroup } from '../../../../../store/modules/rules';

const getStatement = (
  name: string,
  groups: StatementGroup[],
): Statement | null => {
  // eslint-disable-next-line
  for (let i = 0; i < groups.length; i++) {
    const group = groups[i];
    const stm = group.options.find((s: Statement) => (s.name === name));

    if (stm) {
      return stm;
    }
  }
  return null;
};

export default getStatement;
